<script setup>
  import ListeAchats from '@/components/ListeAchats.vue'

</script>

<template>
  <h1>Liste des achats à effectuer</h1>
  <div class="achats">
    <ListeAchats/>
  </div>
</template>

<script>


export default {

}
</script>

<style>

</style>
